import request from '@/utils/request'

// 查询需求列表
export function listTableCategory(data) {
  return request({
    url: '/sysDemand/list',
    method: 'post',
    data,
  })
}

// 新增需求
export function addTable(data) {
  return request({
    url: '/sysDemand/insert',
    method: 'post',
    data: data,
  })
}

// 修改需求
export function updateTable(data) {
  return request({
    url: '/sysDemand/update',
    method: 'post',
    data: data,
  })
}

// 删除需求
export function delTable(data) {
  return request({
    url: `/sysDemand/delete/?id=${data}`,
    method: 'get',
  })
}

// 抢单
export function insertGrabbing(data) {
  return request({
    url: '/sysOrderGrabbing/insert',
    method: 'post',
    data: data,
  })
}
